const swiperIngredients = new Swiper('.swiper-ingredients', {
    // Optional parameters
    loop: false,
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 8,

    breakpoints: {
        768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 48,
        }
    },
  
    // If we need pagination
    pagination: {
      el: '.hoox-swiper-dots2',
      clickable: true,
    },
  
    // Navigation arrows
    navigation: {
      nextEl: '.hoox-swiper-next2',
      prevEl: '.hoox-swiper-prev2',
    },
  });